import type { NookDatabase } from "../infrastructure/database/database";
import {
  studyPath,
  studyTitle,
  planLabels,
  type StudyItem,
  type StudyKind,
} from "../domain/study/model";
export async function studyRows(db: NookDatabase) {
  const drafts = (await db.manualStudyDrafts.toArray()).filter(
      (d) => !d.deletedAt,
    ),
    plans = await db.manualStudyPlans.toArray();
  const rows: {
    id: string;
    kind: string;
    title: string;
    body: string;
    path: string;
    archived: boolean;
    date: string;
    revision: number;
    draft: boolean;
  }[] = [];
  const text = (v: StudyItem) =>
    [
      "自主学习",
      v.title,
      "goal" in v
        ? v.goal + " " + planLabels[v.state]
        : [
            v.body,
            v.gained,
            v.nextStep,
            v.studyDate,
            v.durationMinutes,
            "draft" in v ? "草稿" : "",
            "planId" in v
              ? (plans.find((p) => p.id === v.planId && !p.deletedAt)?.title ??
                "")
              : "",
          ].join("\n"),
    ].join("\n");
  for (const kind of ["study-plan", "study-session"] as StudyKind[]) {
    const items: StudyItem[] =
      kind === "study-plan" ? plans : await db.manualStudySessions.toArray();
    for (const item of items) {
      if (item.deletedAt) continue;
      const d = drafts
          .filter(
            (d) =>
              d.kind === kind &&
              d.targetId === item.id &&
              d.baseRevision === item.revision,
          )
          .sort(
            (a, b) =>
              b.updatedAt.localeCompare(a.updatedAt) ||
              a.id.localeCompare(b.id),
          )[0],
        v = d?.payload ?? item;
      rows.push({
        id: item.id,
        kind: kind + (d ? " 草稿" : ""),
        title: studyTitle(v),
        body: text(v),
        path: studyPath(kind, item.id) + (d ? "/edit?draft=" + d.id : ""),
        archived: !!item.archivedAt,
        date: "studyDate" in v ? v.studyDate : v.updatedAt.slice(0, 10),
        revision: d?.revision ?? item.revision,
        draft: !!d,
      });
    }
    for (const d of drafts.filter((d) => d.kind === kind)) {
      const item = items.find((v) => v.id === d.targetId);
      if (item?.deletedAt || (item && d.baseRevision === item.revision))
        continue;
      rows.push({
        id: d.id,
        kind: kind + " 草稿" + (item ? " · 冲突分支" : ""),
        title: studyTitle(d.payload),
        body: text(d.payload),
        path: studyPath(kind, d.targetId) + "/edit?draft=" + d.id,
        archived: !!item?.archivedAt,
        date:
          "studyDate" in d.payload
            ? d.payload.studyDate
            : d.updatedAt.slice(0, 10),
        revision: d.revision,
        draft: true,
      });
    }
  }
  return rows;
}
